import $ from 'jquery';

$('.header-slider__slider').slick({
	infinite: true,
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: true,
	dots:true,
	autoplay: true,
	autoplaySpeed: 8000,
	fade: true,
	cssEase: 'linear',
	prevArrow: $('.slick-prev'),
	nextArrow: $('.slick-next'),
});